import React, { useEffect, useState } from "react";
import Credin from "../../assets/Credin Logo (1).svg";
import axios from "axios";
import { url } from "../../App";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";

export default function EditUser() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [companyCode, setCompanyCode] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [branchName, setBranchName] = useState("");

  useEffect(() => {
    // console.log(state);
    if (!state) {
        navigate("/");
        console.log("No state found");
      }
      else {
        setUsername(state.name);
        setUserId(state.email);
        // setPassword(state.password);
        setCompanyCode(state.company_code);
        setLatitude(state.branchLat);
        setLongitude(state.branchLong);
        setBranchName(state.branchName);
      }
  },[state,navigate])

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Updating User");
    axios
      .post(url + "/api/update/user", {
        name: username,
        email: userId,
        password: password,
        code: companyCode,
        branchLat: latitude,
        branchLong: longitude,
        branchName: branchName,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.msg === "User successfully created or updated") {
          toast.success(res.data.msg);
          setTimeout(() => {
            navigate("/create");
          }, 3000);
        }
        else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="main-login">
      <div style={{ margin: "2rem" }}>
        <img src={Credin} alt="Credin Logo" width="150" />
      </div>
      <div className="container-create-user">
        <div
          style={{
            fontWeight: "bolder",
            fontSize: "1.5rem",
            margin: ".5rem 0",
          }}
        >
          Edit User
        </div>
        <form onSubmit={handleSubmit}>
          <div className="div-login">
            <label>
              Enter Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              value={username}
              name="username"
              required
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Email Id <span style={{ color: "red" }}>*</span>
            </label>
            <input
              required
              disabled
              name="user-id"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Password <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              required
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Company Code <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              required
              name="company-code"
              value={companyCode}
              onChange={(e) => setCompanyCode(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Latitude <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              required
              name="latitude"
              value={latitude}
              onChange={(e) => setLatitude(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Longitude <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              required
              name="longitude"
              value={longitude}
              onChange={(e) => setLongitude(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Branch Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              required
              name="branch-name"
              value={branchName}
              onChange={(e) => setBranchName(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: ".5rem",
            }}
          >
            <button
              className="btn-login"
              type="submit"
              style={{ margin: "1rem 0" }}
            >
              Update User
            </button>
          </div>
        </form>
        </div>
        <ToastContainer />
        </div>
  )
}
